import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/vant.js'
import 'lib-flexible'

import ImageURL from './config/imageURL'
Vue.prototype.$imageURL = ImageURL

// 浏览器判断
import browser from '@/utils/browser'
Vue.prototype.$browser = browser

// 工具方法
import * as util from '@/utils/util'

Vue.prototype.$util = util

// 页面固定参数
import pageQuery from '@/mixin/commn'
Vue.mixin(pageQuery)

// app唤醒
import { openSchema } from '@/plugins/native_schema.js'
Vue.prototype.$openSchema = openSchema

import BrandConfig from '@/config/brand'
Vue.prototype.$brandConfig = BrandConfig

import Meta from 'vue-meta'
Vue.use(Meta)
Vue.config.productionTip = false

Vue.config.ignoredElements = ['wx-open-launch-app']
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
